<template>
  <SingleSQ
    :questionData="questionData"
    :btnWidth="500"
    :oneOption="false"
    :pendingOption="true"
    :sq_numberData="'sq_fortySixData'"
    :sqOptions="[]"
    :secondRadioB="false"
    @goBackInScoringHistory="goBackInScoringHistory">
  </SingleSQ>
</template>

<script>
import SingleSQ from '@/components/savings/blocks/SingleSQ'

export default {
  name: 'SQuesFortySix',
  components: {
    SingleSQ
  },
  props: {
    questionData: Object
  },
  methods: {
    setData () {
      this.$emit('handleProgress', 20)
    },
    goBackInScoringHistory () {
      this.$emit('goBackInScoringHistory')
    }
  },
  mounted () {
    this.setData()
  }
}
</script>
